/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AddressType {
    UNKNOWN = 'Unknown',
    BILLING = 'Billing',
    DELIVERY = 'Delivery',
}
